import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { Router, RouterOutlet } from '@angular/router';
import { AbstractAppAuthentication } from '../app/app-services/authentication/authentication.app.abstract';
import { AppMonitoring } from '../app/app-services/monitoring/monitor.app';
import { AppSnackBar } from '../app/app-services/snackbar/snackbar.app';
import { AppPwaLaunch } from './app-services/pwa-launch/pwa-launch.app';
import { AppRightDrawer } from './app-services/right-drawer/right-drawer.app';
import { AppServiceWorkerUpdate } from './app-services/service-worker/service-worker-update.app';
import { MaterialDesignConfig } from './app.config.material';
import { LoadingIndicatorComponent } from './components/loading-indicator/loading-indicator.component';
import { ISnackbarBase } from './models/snackbar/snackbar-base.model';
import { SystemInfoComponent } from './components/system-info/system-info.component';

@Component({
    selector: 'app-root',
    imports: [
        CommonModule,
        LoadingIndicatorComponent,
        ...MaterialDesignConfig,
        RouterOutlet,
        SystemInfoComponent
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'IOCO';
  snackbarRef: MatSnackBarRef<SimpleSnackBar> | undefined;

  public displaySystemInfo = false;
  @HostListener('window:keydown', ['$event'])
  checkKeyCombination(event: KeyboardEvent) {
    if (event.ctrlKey && event.altKey && event.shiftKey && event.key.toLocaleLowerCase() === 'i') {
      this.displaySystemInfo = !this.displaySystemInfo;
    } else if (event.key === 'escape') {
      this.displaySystemInfo = false;
    }
  }

  constructor(
    public snackBar: MatSnackBar, private readonly appSnackBar: AppSnackBar,
    private readonly appAuthentication: AbstractAppAuthentication, private readonly appMonitoring: AppMonitoring,
    private readonly router: Router, public appRightDrawer: AppRightDrawer,
    private readonly appServiceWorkerUpdate: AppServiceWorkerUpdate,
    private readonly appPwaLaunch: AppPwaLaunch
  ) {
    this.registerSnackbar();
  }

  ngOnInit(): void {
    this.appAuthentication.handleRedirectObservable();
    this.appAuthentication.registerForAuthenticationEvents();
    this.appServiceWorkerUpdate.registerForVersionUpdates();
    this.appPwaLaunch.registerForCampaignVisits();
  }

  registerSnackbar() {
    this.appSnackBar.onSnackbar.subscribe((snackbarDetails: ISnackbarBase) => {
      this.openSnackBar(snackbarDetails);
    });

    this.appSnackBar.onDismissSnackbar.subscribe(() => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
    this.appMonitoring.logEvent(this, 'Snackbar service registered');
  }

  openSnackBar(
    snackbarDetails: ISnackbarBase): void {
    // This is a example to display a more complex snackbar.
    // To display a simple snackbar, use the default snackBar.open(message, action);
    this.snackbarRef = this.snackBar.openFromComponent(
      snackbarDetails.componentRef
      , {
        data: snackbarDetails.data,
        panelClass: ['custom-snackbar']
      });
  }

  rightDrawerOpenChanged(state: boolean) {
    this.appRightDrawer.isOpen.next(state);
    if (!state) {
      this.router.navigate([{ outlets: { rightDrawer: null } }]);
    }
  }
}
